module.exports = __webpack_public_path__ + "img/s5-title.464c743a.png";